module.exports = __webpack_public_path__ + "static/media/slide4Active.2d523991.png";